<div class="padding flex column">
    <h4 class="bold margin-bottom-small">Approve Note</h4>

    <mat-form-field appearance="outline">
        <mat-label>note</mat-label>
        <textarea [(ngModel)]="note" matInput></textarea>
    </mat-form-field>

    <div class="flex column end margin-top">
        <div class="flex center">

            <button (click)="onClose(false)" class="stroked margin-right-small">
                <i class="fa-solid fa-undo"></i>
                Discard
            </button>

            <button (click)="onClose(true)" [disabled]="!note">
                <i class="fa-solid fa-check"></i>
                Confirm
            </button>
        </div>
    </div>
</div>